module.exports = __webpack_public_path__ + "static/media/10. Planery Session Mohamed Rozani Osman.eef4c432.png";